"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("./constants");
/**
 * Calculates the number of status credits a customer earns from points.
 * Useful for when manually adjusting points earned for a customer i.e. at checkout
 * @param points - The number of points earned.
 * @returns The number of status credits earned given the number of points.
 * @example 1000 => 3, 2750 => 10, 10000 => 36
 */
function calculateLuxLoyaltyStatusCreditsFromPoints(points) {
    return Math.floor(points / constants_1.LUX_LOYALTY_POINTS_PER_STATUS_CREDIT);
}
exports.default = calculateLuxLoyaltyStatusCreditsFromPoints;
